import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import posed from 'react-pose'

const Image = styled.img`
  ${props => (props.position === 'right' ? 'margin-left: 16px;' : null)}
  ${props => (props.position === 'left' ? 'margin-right: 16px;' : null)}
`

const BOX_STYLES = {
  disabled: {
    scale: 1,
    boxShadow: '0 9px 24px 0 rgba(35,41,48,0.15)',
    background: 'linear-gradient(to bottom right, #a9cbe8 0%, #a9cbe8 100%)'
  },
  init: {
    scale: 1,
    boxShadow: '0 9px 24px 0 rgba(35,41,48,0.15)',
    background: 'linear-gradient(to bottom right, #71d77c 0%, #5ac866 100%)'
  },
  hover: {
    scale: 1,
    boxShadow: '0 9px 24px 0 rgba(35,41,48,0.15)',
    background: 'linear-gradient(to bottom right, #5ac866 0%, #71d77c 100%)'
  },
  press: {
    scale: 1,
    boxShadow: '0 9px 24px 0 rgba(35,41,48,0.15)',
    background: 'linear-gradient(to bottom right, #5ac866 0%, #71d77c 100%)'
  }
}

const Box = posed.button({
  hoverable: true,
  pressable: true,
  focusable: true,
  init: {
    ...BOX_STYLES.init
  },
  focus: {
    ...BOX_STYLES.hover,
    boxShadow: props =>
      props.disabled
        ? BOX_STYLES.disabled.boxShadow
        : BOX_STYLES.hover.boxShadow,
    background: props =>
      props.disabled
        ? BOX_STYLES.disabled.background
        : BOX_STYLES.hover.background
  },
  hover: {
    ...BOX_STYLES.hover,
    boxShadow: props =>
      props.disabled
        ? BOX_STYLES.disabled.boxShadow
        : BOX_STYLES.hover.boxShadow,
    background: props =>
      props.disabled
        ? BOX_STYLES.disabled.background
        : BOX_STYLES.hover.background
  },
  press: {
    ...BOX_STYLES.press,
    boxShadow: props =>
      props.disabled
        ? BOX_STYLES.disabled.boxShadow
        : BOX_STYLES.press.boxShadow,
    background: props =>
      props.disabled
        ? BOX_STYLES.disabled.background
        : BOX_STYLES.press.background
  },
  disabled: {
    ...BOX_STYLES.disabled
  }
})

const StyledBox = styled(Box)`
  outline: none;
  -webkit-tap-highlight-color: transparent;
  background: #ffffff;
  border: none;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 45px;
  padding: 17px;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  color: #FFFFFF;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  font-size: 1.05em;
  user-select: none;
  transition: all 0.5s ease;
`
const AttorneyChooseButton = ({
  onClick,
  text,
  image,
  position,
  isMobile,
  disabled,
  disabledText = '',
  type,
}) => {
  const imgProps = {
    position,
    src: image
  }
  return (
    <StyledBox
      pose={disabled ? 'disabled' : 'init'}
      isMobile={isMobile}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      <>
        {image && position === 'left' ? <Image {...imgProps} /> : null}
        {text}
        {image && position === 'right' ? <Image {...imgProps} /> : null}
      </>
    </StyledBox>
  )
}

AttorneyChooseButton.defaultProps = {
  position: 'right',
  isMobile: false,
  disabled: false,
  disabledText: null,
  image: null,
  type: 'button'
}

AttorneyChooseButton.propTypes = {
  isMobile: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledText: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  position: PropTypes.oneOf(['left', 'right']),
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  image: PropTypes.string
}

export default AttorneyChooseButton
